import { render } from "./EditProviderModal.vue?vue&type=template&id=19057980"
import script from "./EditProviderModal.vue?vue&type=script&lang=js"
export * from "./EditProviderModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "19057980"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19057980', script)) {
    api.reload('19057980', script)
  }
  
  module.hot.accept("./EditProviderModal.vue?vue&type=template&id=19057980", () => {
    api.rerender('19057980', render)
  })

}

script.__file = "resources/js/Pages/User/Partials/EditProviderModal.vue"

export default script